export const cruxyColors = {
  green: {
    main: "#BFFC00",
  },
  blue: {
    main: "#0D00FF",
  },
  amber: {
    main: "#FF9500",
  },
  red: {
    main: "#FF0000",
  },
};
